import mixpanel from "mixpanel-browser";
import { IseePaywallTestVariant } from "../../../../constants/isee-paywall-test-variant.enum";
import {
  ISEE_PAYWALL_TEST_EXPOSURE_TRACKED_STORAGE_KEY,
  ISEE_PAYWALL_TEST_PROPERTY,
  MIXPANEL_EXPERIMENT_NAME_PROPERTY,
  MIXPANEL_EXPERIMENT_STARTED_EVENT_NAME,
  MIXPANEL_VARIANT_NAME_PROPERTY,
  PENDING_ISEE_PAYWALL_TEST_ASSIGNMENT_STORAGE_KEY,
} from "./isee-paywall-test.const";

export function isIseePaywallTestAssignedVariant(variant: string | undefined): variant is IseePaywallTestVariant {
  return variant === IseePaywallTestVariant.CONTROL || variant === IseePaywallTestVariant.SIMPLIFAID;
}

function trackFirstExposure(variant: IseePaywallTestVariant): void {
  const isExposureAlreadyTracked = localStorage.getItem(ISEE_PAYWALL_TEST_EXPOSURE_TRACKED_STORAGE_KEY) !== null;
  if (isExposureAlreadyTracked) {
    return;
  }

  mixpanel.track(MIXPANEL_EXPERIMENT_STARTED_EVENT_NAME, {
    [MIXPANEL_EXPERIMENT_NAME_PROPERTY]: ISEE_PAYWALL_TEST_PROPERTY,
    [MIXPANEL_VARIANT_NAME_PROPERTY]: variant,
  });
  localStorage.setItem(ISEE_PAYWALL_TEST_EXPOSURE_TRACKED_STORAGE_KEY, variant);
}

export function assignIseePaywallTest(variant: string): void {
  if (!isIseePaywallTestAssignedVariant(variant)) {
    return;
  }

  if (mixpanel.has_opted_out_tracking()) {
    localStorage.setItem(PENDING_ISEE_PAYWALL_TEST_ASSIGNMENT_STORAGE_KEY, variant);
    return;
  }

  mixpanel.people.set_once({
    [ISEE_PAYWALL_TEST_PROPERTY]: variant,
  });
  trackFirstExposure(variant);
  localStorage.removeItem(PENDING_ISEE_PAYWALL_TEST_ASSIGNMENT_STORAGE_KEY);
}

export function flushPendingIseePaywallTestAssignment(): void {
  const pendingVariant = localStorage.getItem(PENDING_ISEE_PAYWALL_TEST_ASSIGNMENT_STORAGE_KEY);
  if (!pendingVariant) {
    return;
  }

  assignIseePaywallTest(pendingVariant);
}
